import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { dealerHttp } from '@network';
import { Dealer, Doctype } from '@types';
import { useRecord, useRbacEdit } from '@hooks';
import { DealerDocumentsWidget } from './DealerDocumentsWidget';
import cls from './DealerDocuments.module.css';

export const DealerDocuments = () => {
  const record = useRecord<Dealer>();
  const editable = useRbacEdit();
  const [dealer, setDealer] = useState<Dealer | null>(record);
  const [doctypes, setDoctypes] = useState<Doctype[] | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (record?.id) {
      (async () => {
        const [nextDealer, doctypesRes] = await Promise.all([
          dealerHttp.getById(record.id),
          dealerHttp.getDealerDoctypes(record.id),
        ]);
        setDealer(nextDealer);
        setDoctypes(doctypesRes.doctypes);
      })();
    }
  }, [location, record?.id]);

  useEffect(() => {
    if (dealer?.id) {
      (async () => {
        const res = await dealerHttp.getDealerDoctypes(dealer.id);
        setDoctypes(res.doctypes);
      })();
    }
  }, [dealer?.id]);

  if (!dealer) {
    return null;
  }

  return (
    <div className={cls.wrap}>
      <div className={cls.form}>
        <DealerDocumentsWidget
          dealer={dealer}
          setDealer={setDealer}
          doctypes={doctypes}
          editable={editable}
        />
      </div>
    </div>
  );
};
